import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IMemberBooks } from "./routeType";

const { key, getPath } = getApi("members.books.getAll");

type IExtractedRouteType = IMemberBooks["bookCollectionRetrieve"];

export type IGetAllMemberBooks = IPickCollectionQuery<IExtractedRouteType>;

const getAllMemberBooks: Fetcher<
  IGetAllMemberBooks["response"],
  IGetAllMemberBooks["variables"]
> = ({ memberId, ...params }) => {
  return axiosClient.get(getPath({ memberId }), { params });
};

export const useGetAllMemberBooks = createQuery({
  queryKey: [key],
  fetcher: getAllMemberBooks,
});
